import React, { useCallback, useMemo } from 'react';
import { Switch } from '@cognitiv/cyprus-ui';
import { ProjectsQuery } from 'ducks/types/query-types';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { mergeSearchQuery, parseQueries } from 'utils/queries';

import cn from 'components/breadcrumbs/Breadcrumbs.module.scss';

export const Projects = () => {
  const { search } = useLocation();
  const navigate = useNavigate();

  const handleArchived = useCallback(
    (toggle: boolean) => {
      const queries = mergeSearchQuery(search, { include_archived: toggle });
      navigate(`/projects/${queries}`);
    },
    [navigate, search],
  );

  const selectProject = () => `/projects`;

  const { include_archived } = useMemo(() => parseQueries<ProjectsQuery>(search), [search]);
  return (
    <div className={cn.items}>
      <Link className={cn.item} to={selectProject()}>
        Projects
      </Link>
      <div className={cn.flexGrow} />
      <div className={cn.switchWrapper}>
        <Switch
          append_label="Include Archived"
          onClick={handleArchived}
          checked={include_archived}
          margin="0 34px 0 0"
          width="max-content"
        />
      </div>
    </div>
  );
};
